import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link, useNavigate } from "react-router-dom";
import { Row, Col, BreadcrumbItem, Button } from "reactstrap";

const Breadcrumb = (props) => {
  const navigate = useNavigate();
  let cleanUrl
  if (props?.path !== undefined) {
     const [base] = props?.path?.split("?");
         cleanUrl = base.slice(-1) === '/' ? base.slice(0, -1) : base;
  }
 
  return (
    <Row>
      <Col className="col-12">
        <div className="page-title-box d-sm-flex align-items-center justify-content-between pb-2">
          {props.isBack ? (
            <div className="d-flex justify-content-start align-items-center">
              <Button
                onClick={() => navigate(props?.path ? props?.path : -1)}
                className="me-3"
                style={{whiteSpace: "nowrap"}}
              >
                <i className="fas fa-angle-left"></i> กลับ
              </Button>
              <h4 className="mb-sm-0 font-size-18">{props?.subMenuName}</h4>
            </div>
          ) : (
            <h4 className="mb-sm-0 font-size-18">
                {props?.breadcrumbText !== undefined ? props?.breadcrumbText :props?.breadcrumbItem}
            </h4>
          )}
          <div className="page-title-right">
            {(!props.main && props?.title && props?.breadcrumbItem) && (
              <ol className="breadcrumb m-0">
                {props?.title && (
                  <BreadcrumbItem>
                    <Link to="/">{props.title}</Link>
                  </BreadcrumbItem>
                )}

              {props?.breadcrumbItem.split("/").length > 1 ?
                props?.breadcrumbItem.split("/").map((item, idx) =>{ 
                  return(
                    <BreadcrumbItem active>
                      <Link to={cleanUrl}>{item}</Link>
                    </BreadcrumbItem>
                  )
                })
              : <BreadcrumbItem active>
                  <Link to={props?.isSubMenu ? cleanUrl : props?.path}>{props?.breadcrumbItem}</Link>
                </BreadcrumbItem>}

                {props?.isSubMenu && (
                  <BreadcrumbItem active>
                  <Link to={props.path}>{props?.subMenuName}</Link>
                </BreadcrumbItem>
                )}
            </ol>
            )}
            {(props.main && props?.title && props?.breadcrumbItem) && (
                <ol className="breadcrumb m-0">
                     <BreadcrumbItem>
                       <Link to={props?.home && "/"}>{props?.title}</Link>
                     </BreadcrumbItem>
                </ol>
            )}
          </div>
        </div>
      </Col>
    </Row>
  );
};

Breadcrumb.propTypes = {
  breadcrumbItem: PropTypes.string,
  title: PropTypes.string,
};

export default Breadcrumb;
